import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { IModuleDispatch, IModuleState } from './moduleStore';

export const useModuleDispatch: () => IModuleDispatch = useDispatch;
export const useModuleSelector: TypedUseSelectorHook<IModuleState> =
  useSelector;
